import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

// TO DO//
// Find a better way to do this.  We currently use playlistEntryItems to get
// around memoization
export const playlistEntryItems = state =>
  state.orm.playlistEntries ? state.orm.playlistEntries.items : {}

export const getPlaylistEntry = (state, id) => {
  const selector = createSelector(
    state => state.orm,
    ormCreateSelector(orm, session => {
      return session.PlaylistEntries.withId(id)
    })
  )

  return selector(state)
}

export const getPlaylistEntries = (state, uuid) => {
  const selector = createSelector(
    state => state.orm,
    playlistEntryItems,
    ormCreateSelector(orm, session => {
      if (uuid) {
        return session.PlaylistEntries.all()
          .filter(entry => entry.playlist === uuid)
          .orderBy('orderBy')
      } else {
        return session.PlaylistEntries.all()
      }
    })
  )
  return selector(state)
}
